mutation UPDATE_PARKING_SCHEDULE (
  $id: UUID!
  $availableReservationTypes: [ReservationTypeEnum]
  $blackoutDates: [Date]
  $closingTime: Time!
  $endDate: Date!
  $name: String
  $notes: String
  $openingTime: Time!
  $price: Decimal!
  $priceHourly: Decimal!
  $priority: Int
  $spots: Int
  $startDate: Date!
  $surgeFactor: Decimal
  $appliesToDays: [String]!
  $priceOvernight: Decimal
  $maxConsecutiveReservationDays: Int
  ) {
  updateParkingSchedule(
    id: $id
    availableReservationTypes: $availableReservationTypes
    maxConsecutiveReservationDays: $maxConsecutiveReservationDays
    blackoutDates: $blackoutDates
    closingTime: $closingTime
    endDate: $endDate 
    name: $name
    notes: $notes
    openingTime: $openingTime
    price: $price
    priceHourly: $priceHourly 
    priority: $priority
    spots: $spots 
    startDate: $startDate
    surgeFactor: $surgeFactor
    appliesToDays: $appliesToDays
    priceOvernight: $priceOvernight
  ) {
    success
    error
  }
}
